export class APIClientError extends Error {
  public readonly status?: number;
  public readonly statusText?: string;
  public readonly path?: string;

  public constructor(message: string, status?: number, statusText?: string, path?: string) {
    super(message);
    this.name = 'APIClientError';
    Object.defineProperty(this, 'status', { value: status, writable: false });
    Object.defineProperty(this, 'statusText', { value: statusText, writable: false });
    Object.defineProperty(this, 'path', { value: path, writable: false });
  }
}
